import { useCompanyAllowlist } from "./UseCompanyAllowlist";

const BETA_TESTERS: string[] = [
  '24adbc1c-904c-4091-ba95-46323cd04431', // TT Prod
  '692b0efb-b3ae-4656-a11b-e37ae599a636', // TT Test
];

export function IsBetaTester() {
  return useCompanyAllowlist(BETA_TESTERS);
}
